import { isQrCapableModeType } from "./modeTypes";

// #1866 — pure QR-URL builder, exported for unit testing (mirrors
// ClassResultsPage's groupResultsByDivision pattern: a real call site's own
// logic, not a reimplementation of it). A board addressed by usefCompId
// (#1703 short form) has a raw route `showId` param that is NOT the show's
// real entity id — resolveClassByNumber/getPublicClassResults (the QR
// target's two lookups) do a bare GetCommand by entity id with no
// usefCompId fallback, so a QR built from the raw param is a dead link.
// score-api's getPublicScoreboard now returns the show's OWN resolved
// entity id as `data.showId` (#1866) for exactly this reason — prefer it
// over the raw route param, same "prefer the resolved server value" shape
// already used for `yearForQr` below. Falls back to the raw route param
// only when the server hasn't returned one yet (no poll has landed).
export function buildScoreboardQrUrl({ origin, routeShowId, data, routeYear }) {
  if (!isQrCapableModeType(data?.mode?.modeType)) return null;
  const classNumberForQr = data?.fields?.classNumberName?.classNumber ?? null;
  if (!classNumberForQr) return null;
  const yearForQr = data?.year ?? routeYear;
  if (!yearForQr) return null;
  const showIdForQr = data?.showId ?? routeShowId;
  return `${origin}/results/${encodeURIComponent(showIdForQr)}/${encodeURIComponent(yearForQr)}/${encodeURIComponent(classNumberForQr)}`;
}
